import { Link } from 'react-router-dom'
import { Logo } from '@/components/Logo'
import { Icon } from '@/components/Icon'
import { SITE } from '@/data/site'
import { ENV, ICP_BEIAN_URL } from '@/config/env'

const NAV = [
  { to: '/', label: '首页' },
  { to: '/services', label: '核心服务' },
  { to: '/about', label: '关于我们' },
]

const SERVICES = [
  '互联网信息服务',
  '在线数据处理与交易',
  '安全与合规服务',
  '技术开发与运维',
]

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Logo />
            <p className="footer-company">{SITE.companyName}</p>
            <p className="footer-desc">{SITE.description}</p>
            <div className="footer-socials">
              {SITE.socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="footer-social"
                  aria-label={s.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">快速导航</h4>
            <ul className="footer-links">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">核心服务</h4>
            <ul className="footer-links">
              {SERVICES.map((s) => (
                <li key={s}>
                  <Link to="/services">{s}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-title">联系我们</h4>
            <ul className="footer-contact">
              <li>
                <Icon name="mail" size={16} />
                <span>{SITE.contact.email}</span>
              </li>
              <li>
                <Icon name="location" size={16} />
                <span>{SITE.contact.address}</span>
              </li>
              <li>
                <Icon name="data" size={16} />
                <span>统一社会信用代码 {ENV.creditCode || SITE.legal.creditCode}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {ENV.companyName || SITE.name} · {SITE.name} 官网。保留所有权利。
          </p>
          <p className="footer-bottom-links">
            <a href={ICP_BEIAN_URL} target="_blank" rel="noopener noreferrer">
              {ENV.icpNo}
            </a>
            <span>·</span>
            <span>{ENV.icpDomain}</span>
            <span>·</span>
            <span>统一社会信用代码：{ENV.creditCode || SITE.legal.creditCode}</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
